import React, { Component } from "react";
import AuthHeader from "./Header/AuthHeader";
import { Notify } from "react-redux-notify";
import AuthFooter from "./Footer/AuthFooter";

class AuthLayout extends Component {
  componentDidMount() {
    document.title = "Rebel | The Home of Bahamian Creators";
  }
  state = {};
  render() {
    return (
      <div>
        <Notify position="TopRight" />
        {/* <AuthHeader /> */}
        <div className="gradient-bg">
          {React.cloneElement(this.props.children)}
        </div>
        {/* <AuthFooter /> */}
      </div>
    );
  }
}

export default AuthLayout;
